import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiSharedDoc\DeleteWikiSharedDocumentByIdController::deleteMethod
* @see app/Http/Controllers/WikiSharedDoc/DeleteWikiSharedDocumentByIdController.php
* @route '/api/wiki-shared-docs/{wiki_shared_doc}'
*/
export const deleteMethod = (args: { wiki_shared_doc: string | { id: string } } | [wiki_shared_doc: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/wiki-shared-docs/{wiki_shared_doc}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\WikiSharedDoc\DeleteWikiSharedDocumentByIdController::deleteMethod
* @see app/Http/Controllers/WikiSharedDoc/DeleteWikiSharedDocumentByIdController.php
* @route '/api/wiki-shared-docs/{wiki_shared_doc}'
*/
deleteMethod.url = (args: { wiki_shared_doc: string | { id: string } } | [wiki_shared_doc: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_shared_doc: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { wiki_shared_doc: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_shared_doc: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_shared_doc: typeof args.wiki_shared_doc === 'object'
        ? args.wiki_shared_doc.id
        : args.wiki_shared_doc,
    }

    return deleteMethod.definition.url
            .replace('{wiki_shared_doc}', parsedArgs.wiki_shared_doc.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiSharedDoc\DeleteWikiSharedDocumentByIdController::deleteMethod
* @see app/Http/Controllers/WikiSharedDoc/DeleteWikiSharedDocumentByIdController.php
* @route '/api/wiki-shared-docs/{wiki_shared_doc}'
*/
deleteMethod.delete = (args: { wiki_shared_doc: string | { id: string } } | [wiki_shared_doc: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\WikiSharedDoc\DeleteWikiSharedDocumentByIdController::undo
* @see app/Http/Controllers/WikiSharedDoc/DeleteWikiSharedDocumentByIdController.php
* @route '/api/wiki-shared-docs/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/wiki-shared-docs/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiSharedDoc\DeleteWikiSharedDocumentByIdController::undo
* @see app/Http/Controllers/WikiSharedDoc/DeleteWikiSharedDocumentByIdController.php
* @route '/api/wiki-shared-docs/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiSharedDoc\DeleteWikiSharedDocumentByIdController::undo
* @see app/Http/Controllers/WikiSharedDoc/DeleteWikiSharedDocumentByIdController.php
* @route '/api/wiki-shared-docs/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiSharedDoc\DeleteWikiSharedDocumentByIdController::undo
* @see app/Http/Controllers/WikiSharedDoc/DeleteWikiSharedDocumentByIdController.php
* @route '/api/wiki-shared-docs/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteWikiSharedDocumentByIdController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteWikiSharedDocumentByIdController